var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "main-title" }, [_vm._v("店铺信息")]),
    _vm._v(" "),
    _c(
      "div",
      { staticStyle: { width: "800px", margin: "0 auto" } },
      [
        _c(
          "el-form",
          {
            ref: "form",
            attrs: {
              model: _vm.form,
              rules: _vm.formRules,
              "label-width": "150px"
            }
          },
          [
            _c(
              "a-spin",
              { attrs: { spinning: _vm.spinning } },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "店铺名称", prop: "shopName" } },
                  [
                    _c("el-input", {
                      attrs: {
                        disabled: _vm.formDisabel,
                        maxlength: "15",
                        "show-word-limit": "",
                        placeholder: "请输入店铺名称"
                      },
                      model: {
                        value: _vm.form.shopName,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "shopName", $$v)
                        },
                        expression: "form.shopName"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "经营区域", prop: "areaCodes" } },
                  [
                    _c(
                      "el-select",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          disabled: _vm.formDisabel,
                          multiple: "",
                          placeholder: "请选择经营区域"
                        },
                        model: {
                          value: _vm.form.areaCodes,
                          callback: function($$v) {
                            _vm.$set(_vm.form, "areaCodes", $$v)
                          },
                          expression: "form.areaCodes"
                        }
                      },
                      _vm._l(_vm.options, function(item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "商家电话", prop: "shopPhone" } },
                  [
                    _c("el-input", {
                      attrs: {
                        disabled: _vm.formDisabel,
                        placeholder: "请输入商家电话"
                      },
                      model: {
                        value: _vm.form.shopPhone,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "shopPhone", $$v)
                        },
                        expression: "form.shopPhone"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "客服微信号", prop: "shopWechat" } },
                  [
                    _c("el-input", {
                      attrs: {
                        disabled: _vm.formDisabel,
                        placeholder: "请输入客服微信号"
                      },
                      model: {
                        value: _vm.form.shopWechat,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "shopWechat", $$v)
                        },
                        expression: "form.shopWechat"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                !_vm.formDisabel
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "所在地区", prop: "shopAdressTown" } },
                      [
                        _c("el-cascader", {
                          staticStyle: { width: "100%" },
                          attrs: {
                            disabled: _vm.formDisabel,
                            placeholder: "请选择所在地区",
                            options: _vm.locationData
                          },
                          on: { change: _vm.handleChange },
                          model: {
                            value: _vm.location,
                            callback: function($$v) {
                              _vm.location = $$v
                            },
                            expression: "location"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.formDisabel
                  ? _c(
                      "el-form-item",
                      { attrs: { label: "所在地区", prop: "shopAdressTown" } },
                      [
                        _c("el-input", {
                          attrs: {
                            placeholder: "请选择所在地区",
                            disabled: _vm.formDisabel
                          },
                          model: {
                            value: _vm.locationStr,
                            callback: function($$v) {
                              _vm.locationStr = $$v
                            },
                            expression: "locationStr"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "店铺详细地址", prop: "shopAdressDetail" }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        disabled: _vm.formDisabel,
                        placeholder: "请输入店铺详细地址",
                        type: "textarea",
                        autosize: { minRows: 2, maxRows: 2 },
                        maxlength: "100",
                        "show-word-limit": ""
                      },
                      model: {
                        value: _vm.form.shopAdressDetail,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "shopAdressDetail", $$v)
                        },
                        expression: "form.shopAdressDetail"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  { attrs: { label: "店铺简介", prop: "shopIntroduce" } },
                  [
                    _c("el-input", {
                      attrs: {
                        disabled: _vm.formDisabel,
                        placeholder: "请输入店铺简介",
                        type: "textarea",
                        autosize: { minRows: 5, maxRows: 8 },
                        maxlength: "1000",
                        "show-word-limit": ""
                      },
                      model: {
                        value: _vm.form.shopIntroduce,
                        callback: function($$v) {
                          _vm.$set(_vm.form, "shopIntroduce", $$v)
                        },
                        expression: "form.shopIntroduce"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "checked-box" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "el-checkbox",
                        {
                          attrs: { disabled: _vm.formDisabel },
                          model: {
                            value: _vm.checked,
                            callback: function($$v) {
                              _vm.checked = $$v
                            },
                            expression: "checked"
                          }
                        },
                        [_vm._v("\n              我已同意\n            ")]
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "checked",
                          class: _vm.formDisabel ? "disabel" : "",
                          on: {
                            click: function($event) {
                              _vm.showChecked = !_vm.formDisabel
                            }
                          }
                        },
                        [
                          _vm._v(
                            "\n              《商家入驻协议》\n            "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticStyle: { "text-align": "right" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { disabled: _vm.formDisabel, type: "primary" },
                          on: { click: _vm.submitForm }
                        },
                        [_vm._v("\n              提交\n            ")]
                      )
                    ],
                    1
                  )
                ])
              ],
              1
            )
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "el-dialog",
          {
            attrs: {
              title: "商家入驻协议",
              visible: _vm.showChecked,
              width: "40%",
              "show-close": true,
              "close-on-click-modal": false
            },
            on: {
              "update:visible": function($event) {
                _vm.showChecked = $event
              }
            }
          },
          [
            _c("div", [
              _c("iframe", {
                attrs: {
                  src: "http://app.xhngyl.com/apk/protocol/xhnUser.html",
                  frameborder: "0",
                  width: "100%",
                  height: "450px"
                }
              })
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "text-align": "right", "margin-top": "30px" } },
              [
                _c(
                  "el-button",
                  {
                    on: {
                      click: function($event) {
                        _vm.showChecked = false
                      }
                    }
                  },
                  [_vm._v(" 关闭 ")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary" },
                    on: {
                      click: function($event) {
                        _vm.showChecked = false
                      }
                    }
                  },
                  [_vm._v("\n          确定\n        ")]
                )
              ],
              1
            )
          ]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-211973f0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-211973f0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/userCenter/shopData/index.vue
// module id = null
// module chunks = 